var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultActiveColor, defaultColor } from '../utils';
const Bookmark = (_a) => {
    var { size = 24, color = defaultColor, activeColor = defaultActiveColor, isActive } = _a, rest = __rest(_a, ["size", "color", "activeColor", "isActive"]);
    return (React.createElement("svg", Object.assign({ width: size, height: size, fill: "none", viewBox: "0 0 24 24" }, rest), isActive ? (React.createElement("path", { fill: activeColor, d: "M6 2c-1.156 0-2 .965-2 2v18.04l8-2.974 8 2.973V4c0-.523-.191-1.055-.566-1.43-.38-.379-.91-.57-1.434-.57H6z" })) : (React.createElement("path", { fill: color, d: "M6 2c-1.156 0-2 .965-2 2v18.04l8-2.974 8 2.973V4c0-.523-.191-1.055-.566-1.43-.38-.379-.91-.57-1.434-.57H6zm0 2h12v15.16l-6-2.226-6 2.226V4z" }))));
};
export default Bookmark;
